import { useCallback } from "react";
import { printTable } from "../util/table-export";

export const useTablePrint = () => {
  const handlePrint = useCallback(
    (columns: any[], data: any[], title: string = "Report") => {
      const timestamp = new Date()
        .toLocaleDateString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
        })
        .replace(/ /g, "_");

      printTable(columns, data, {
        title: `${title} - ${timestamp}`,
        columns: columns,
      });
    },
    []
  );

  return { handlePrint };
};
